"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  LIST: "@@analytic/list",
  LIST_ANALYTICS_DATA: "@@analytic/list-analytices-data",
  SNAPSHOT_LIST: "@@analytic/snapshot-list",
  RESET: "@@analytic/reset",
  RESET_SNAPSHOT: "@@analytic/snapshot-list-reset",
  RESET_CHANGE_LOG: "@@analytic/changelog-list-reset",
  SUCCESS: "@@analytic/success",
  ERROR: "@@analytic/error",
  FETCH_RECORD_SCORE: "@@analytic/fetch-record-score",
  CHANGE_LOG_LIST: "@@analytic/change-log-list",
  CHANGE_LOG_LIST_PLATFORM: "@@analytic/change-log-list-platform",
  CHANGE_LOG_CHANGES_PERFORMED_LIST: "@@analytic/change-log-changes-performed-list",
  CHANGE_LOG_MEDIUM_LIST: "@@analytic/change-log-medium-list",
  CHANGE_LOG_MODULE_LIST: "@@analytic/change-log-module-list",
  CHANGE_LOG_COMPONENT_LIST: "@@analytic/change-log-component-list",
  CHANGE_LOG_ACTOR_LIST: "@@analytic/change-log-actor-list",
  // analytics
  ANALYTICS_SAVE: "@@recipient/analytics_save",
  ANALYTICS_GET: "@@recipient/analytics_get",
  ANALYTICS_UPDATE: "@@recipient/analytics_update",
  ANALYTICS_RECENT_ACTIVITY: "@@recipient/analytics_recent_activity",
  ANALYTICS_FIND: "@@recipient/analytics_find",
  ANALYTICS_ACTIVITY_LOG_HISTORY: "@@recipient/analytics_activity_log_history",
  ANALYTICS_LATEST_SESSION_RECORDING: "@@recipient/analytics_latest_session_recording",
  ANALYTICS_SCORE: "@@recipient/analytics_score"
};
exports.actionTypes = actionTypes;